import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { State, IStore } from "../../../../Account/DataTypes/storeTypes";
import { updateState } from "../../../../Account/Actions/actions";

import { LoginConnected } from "../../../../Account/React/Pages/Login";
import { RecoverConnected } from "../../../../Account/React/Pages/Recover";
import { RegisterConnected } from "../../../../Account/React/Pages/Register";

interface IProps {
    state: State;

    onModalClosed();
}

class Login extends Component<IProps> {
    render() {
        let title = null;
        let page = null;
        switch (this.props.state) {
            case State.Login:
                title = "Log in";
                page = <LoginConnected />;
                break;
            case State.Register:
                title = "Register account";
                page = <RegisterConnected />;
                break;
            case State.Recover:
                title = "Create or reset my log in details";
                page = <RecoverConnected />;
                break;
        }

        return (
            <>
                <div className="row">
                    <div className="col-12 text-center">
                        <h3 className="question">{title}</h3>
                    </div>
                </div>
                <div className="row login-inline">
                    <div className="col-11 col-md-8 ml-auto mr-auto">{page}</div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        state: state.common.state,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        onModalClosed: () => {
            dispatch(updateState(State.None));
        },
    };
};

export const LocalLoginConnected: ConnectedComponent<typeof Login, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);
